// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3OZEe","boxSizing":"style_boxSizing__MogQr","buttonContainer":"style_buttonContainer__1W1jA","title":"style_title__2lgun"};